import { Stack, useMediaQuery } from "@mui/material";

import { mobileWidth } from "../theme/theme";

type ASTableV2SearchAndFilterProps = {
  searchComponent?: React.ReactNode;
  filterComponent?: React.ReactNode;
};

export const ASTableV2SearchAndFilter = ({
  searchComponent,
  filterComponent
}: ASTableV2SearchAndFilterProps) => {
  const isMobile = useMediaQuery(mobileWidth);

  if (!searchComponent && !filterComponent) {
    return null;
  }

  return (
    <Stack
      sx={{
        flexDirection: "row",
        gap: 2,
        alignItems: "center",
        flex: "1 1 auto",
        maxWidth: isMobile ? "100%" : 400
      }}
      role="group"
      aria-label="Search and filter controls"
    >
      {searchComponent}
      {filterComponent}
    </Stack>
  );
};
